export const formHasErrors = (form: any) => {
    return !form.getFieldsError().every((field: any) => field.errors.length === 0);
}